const ASSET_HOST = "assets.veya.co.nz";
const CLOUDFLARE_TRANSFORM_HOST = "https://assets.veya.co.nz";

function cleanNumber(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : fallback;
}

function normaliseToAssetHost(value) {
  if (!value || typeof value !== "string") return value;

  if (value.includes(ASSET_HOST)) return value;

  const r2Match = value.match(/^https?:\/\/[^/]+\.r2\.dev\/(.+)$/i);
  if (r2Match?.[1]) {
    return `https://${ASSET_HOST}/${r2Match[1]}`;
  }

  return value;
}

export function optimizedImageUrl(src, options = {}) {
  if (!src || typeof src !== "string") return src;

  const value = src.trim();
  if (!value) return value;

  if (
    value.startsWith("data:") ||
    value.startsWith("blob:") ||
    value.startsWith("file:") ||
    value.startsWith("/")
  ) {
    return value;
  }

  if (value.includes("/cdn-cgi/image/")) return value;

  const assetUrl = normaliseToAssetHost(value);

  if (!assetUrl.includes(ASSET_HOST)) return value;

  const width = cleanNumber(options.width, 900);
  const quality = cleanNumber(options.quality, 80);
  const format = options.format || "auto";

  const transforms = [
    `format=${format}`,
    `quality=${quality}`,
    `width=${width}`,
  ].join(",");

  return `${CLOUDFLARE_TRANSFORM_HOST}/cdn-cgi/image/${transforms}/${assetUrl}`;
}

export function optimizedBackgroundImage(src, options = {}) {
  const url = optimizedImageUrl(src, options);
  return url ? `url("${url}")` : undefined;
}